import { apiPost } from "@/core/api";
import { engagementId, sessionState } from "@/core/session";

export enum InteractionType {
    IMPRESSION = "IMPRESSION",
    CLICK = "CLICK",
    PROGRESS = "PROGRESS",
    CANCELLATION = "CANCELLATION",
    COMPLETION = "COMPLETION",
    ERROR = "ERROR"
}

export const logFeatureInteraction = async (context: string, featureId: string, type: InteractionType, data?: string) => {
    const events = [{
        featureId: featureId,
        sessionId: sessionState.session?.id,
        engagementId: engagementId.value,
        type: type,
        context: "citizenPortal/" + context,
        data: data
    }];

    apiPost(
        'analytics/citizens/features',
        {events: events}
    );
};